import { useQuery } from '@tanstack/react-query';

import { getPaymentDetails } from '../../apis/paymentDetails';

export type PaymentStatusInput =
  | 'succeeded'
  | 'paid'
  | 'failed'
  | 'canceled'
  | 'unpaid'
  | 'pending'
  | 'refunded'
  | 'refund_requested';

export interface IRefundDetails {
  id: number;
  amount: string;
  reason: string;
  other_reason: string | null;
  notes: string;
  status: string;
}

export interface IPaymentDetails {
  id: number;
  amount: string;
  patient_id: string;
  payment_intent_id: string;
  status: PaymentStatusInput;
  description: string;
  patient_full_name: string;
  invoice_number: string;
  billing_date: string;
  date_of_payment: string;
  payment_method: string;
  refund_details?: IRefundDetails;
  invoice_id: string;
}

export interface IPaymentDetailsResponse {
  success: boolean;
  data?: IPaymentDetails;
  message: string;
  errors?: string[];
}

export function usePaymentDetails(id: string) {
  const query = useQuery<IPaymentDetailsResponse>({
    queryKey: ['payment-details', id],
    queryFn: () => getPaymentDetails(id),
    enabled: !!id,
  });
  const data = query?.data;

  return {
    isLoading: query.isLoading,
    isError: query.isError,
    payment: data?.data,
    message: data?.message || '',
    success: data?.success || false,
    errors: data?.errors || [],
  };
}
